import React from 'react';
import PropTypes from 'prop-types';

import NotEditableBox from './not-editable-box';
import EditableBox from './editable-box';

import styled, { css } from 'styled-components';

export const Index = styled.span`
    ${({ theme }) => css`
        line-height: ${theme.space.regular}px;
        font-size: 16px;
        font-weight: 600;
    `}
`;

const CheckerStep = ({
    index = 1,
    validation,
    isCorrection = false,
    isDisabled,
    isOpened,
    content = '',
    onChange,
    onDelete,
    onOpen,
    onConfirm,
}) => {
    if (!isOpened || isCorrection) {
        return (
            <>
                <Index>{`${index}.`}</Index>
                <NotEditableBox content={content} isCorrection={isCorrection} validation={validation} onClick={() => onOpen()} />
            </>
        );
    }

    return (
        <>
            <Index>{`${index}.`}</Index>
            <EditableBox
                content={content}
                onClick={() => onDelete()}
                onChange={(value) => onChange(value)}
                onConfirm={() => onConfirm(content)}
                isDisabled={isDisabled}
            />
        </>
    );
};

CheckerStep.propTypes = {
    index: PropTypes.number,
    isCorrection: PropTypes.bool,
    isDisabled: PropTypes.bool,
    isOpened: PropTypes.bool,
    validation: PropTypes.any,
    content: PropTypes.string,
    onChange: PropTypes.func,
    onDelete: PropTypes.func,
    onOpen: PropTypes.func,
    onConfirm: PropTypes.func,
};

export default CheckerStep;
